import { NepProviderId } from '~/tenants/nep/model/NepProvider';
import { ProviderPublic, ProviderStaticConfig } from '~/lib/model';

/**
 * The PUBLIC half of each provider's record: what may ship to the browser.
 * Email, phone, addresses and pay live in ./providers.server.ts and are
 * merged into these same objects on the server (tenants/providers.server.ts).
 */
const NEP_PROVIDERS_PUBLIC: Record<NepProviderId, ProviderPublic<ProviderStaticConfig>> = {
  [NepProviderId.SOPHIA]: {
    first: 'Sophia',
    headshot: 'avatar.jpg',
    last: 'Bednarik',
    location: 'nl',
  },
};

/** Typed whole for the code that reads it; on the client the private fields are absent. */
export const NEP_PROVIDERS = NEP_PROVIDERS_PUBLIC as Record<NepProviderId, ProviderStaticConfig>;
